import React, { useRef, useState } from "react";

import { useBreakpoint } from "../../../hooks/useBreakpoint";
import SwiperGallery from "./swiperGallery";
import GalleryBtnWithModal from "../galleryBtnWithModal";
import { getSourceImageUrlToCGI } from "../../../utils/base";
import VideoCard from "../../cards/videoCard";

const GridGallery = ({
  containerClass = "relative w-full gallery-wrapper hidden sm:block",
  gallery = [],
  videoGallery = [],
  featuredSingleVideo = "",
  showGalleryNav = true
}) => {
  const breakpoint = useBreakpoint();
  const firstGalleryElement = gallery && gallery[0] ? gallery[0] : "";

  const featuredVideoGallery = videoGallery?.slice(0, 2) ?? [];
  const featuredVideoGalleryCnt = featuredVideoGallery?.length;
  const imageGallery =
    featuredVideoGalleryCnt > 0
      ? gallery?.slice(
          1,
          parseInt(parseInt(4) - parseInt(featuredVideoGalleryCnt))
        )
      : gallery?.slice(1);
  const showGalleryIdxMarker =
    featuredVideoGalleryCnt > 0
      ? parseInt(parseInt(2) - parseInt(featuredVideoGalleryCnt))
      : 2;

  // console.debug("using mobile gallery");
  return (
    <div className={containerClass}>
      <div className="grid grid-cols-2  grid-rows-2  gap-2 md:grid-cols-3 md:gap-4 program-gallery md:grid-rows-[400px_120px]">
        <div
          className="relative md:h-full h-[40vw] overflow-hidden text-white bg-transparent bg-center bg-no-repeat bg-cover rounded-md project-video"
          style={{
            gridColumn: "1/4",
            backgroundImage: `url(${getSourceImageUrlToCGI({
              uri: encodeURI(
                firstGalleryElement?.localFile &&
                  firstGalleryElement?.localFile?.publicURL
                  ? firstGalleryElement.localFile?.publicURL
                  : firstGalleryElement?.sourceUrl
              )
            })})`
          }}
          dangerouslySetInnerHTML={{
            __html: featuredSingleVideo
          }}
        />
        <div className="grid grid-cols-3 sm:grid-cols-3 gap-2 md:gap-4 col-span-full auto-rows-auto">
          {featuredVideoGallery &&
            featuredVideoGallery?.map((videos, idx) => {
              const video = videos?.genVideoUrl;
              return (
                <VideoCard
                  key={idx}
                  featVideos={video}
                  cardClass="relative bg-center bg-no-repeat bg-cover rounded-md sm:h-full grid-row-span-1 h-full py-1"
                />
              );
            })}
          {imageGallery &&
            imageGallery?.map((galleryItem, idx) => {
              if (idx < showGalleryIdxMarker)
                return (
                  <div
                    key={`gitem-${idx}`}
                    className="bg-center bg-no-repeat bg-cover rounded-md grid-row-span-1 md:h-auto h-[32vw]"
                    data-temp={idx + " - " + breakpoint}
                    style={{
                      marginRight:
                        idx === 1 && breakpoint === "xs" ? "-.5rem" : "0",
                      backgroundImage: `url(${getSourceImageUrlToCGI({
                        uri: encodeURI(
                          galleryItem?.localFile &&
                            galleryItem?.localFile?.publicURL
                            ? galleryItem?.localFile?.publicURL
                            : galleryItem?.sourceUrl
                        )
                      })})`
                    }}
                    data-id={`gitem-${idx}`}
                  />
                );
              else if (idx === showGalleryIdxMarker)
                return (
                  <div
                    key={`gitem-${idx}`}
                    className="relative md:h-auto h-[32vw] bg-center bg-no-repeat bg-cover rounded-md"
                    style={{
                      backgroundImage: `url(${getSourceImageUrlToCGI({
                        uri: encodeURI(
                          galleryItem?.localFile &&
                            galleryItem?.localFile?.publicURL
                            ? galleryItem?.localFile?.publicURL
                            : galleryItem?.sourceUrl ?? galleryItem?.type
                        )
                      })})`
                    }}
                  >
                    <div className="relative w-full md:absolute program-gallery-more bottom-14 md:bottom-4 ">
                      <GalleryBtnWithModal
                        galleryPhotos={gallery}
                        featVideo={featuredSingleVideo}
                        programFeaturedVideoTestimonials={videoGallery}
                      />
                    </div>
                  </div>
                );
              else return <></>;
            })}
        </div>
      </div>
    </div>
  );
};

export default GridGallery;
